var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"deposit"},[_c('div',{staticClass:"deposit_1"},[_c('div',{class:_vm.index_active==4?'active':''},[_c('router-link',{attrs:{"to":"/blockchain_d/deposit_jmhb"}},[_vm._v(_vm._s(_vm.$t('main.text748')))])],1)]),_c('router-view')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }